import React, { useState, useEffect } from "react";
import TextInputNoLabel from "../../../ShareElements/TextInput/TextInputNolabel";
import SimpleTextArea from "../../../ShareElements/TextInput/TextAreaNolabel";
import Switch from "../../../ShareElements/TextInput/Switch";
import UnsavedChangesAlert from "../../../ShareElements/UnsavedChangesAlert/UnsavedChangesAlert";
import axios from "axios";
import Rotator from "../../../../../../Assets/Images/ButtonLoadingIcon.svg";
import { Config } from "../../../../../../Config";
import Select from "../../../ShareElements/Select/Select";

const BasicSettings = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };
  const [IsLoading, setIsLoading] = useState(false);
  const [CreateIsDone, setCreateIsDone] = useState(false);
  const [ChangesApplied, setChangesApplied] = useState(false);
  const [UnsavedChanges, setUnsavedChanges] = useState(false);
  const [CreatedProfile, setCreatedProfile] = useState({});
  const [ProfileTypes] = useState([
    { id: "HR_ADMIN", name: "HR Admin" },
    { id: "EMPLOYEE_SELF_SERVICE", name: "Employee self-service" },
    { id: "MANAGER_SELF_SERVICE", name: "Manager self-service" },
    { id: "CX_ADMIN", name: "CX Admin" },
  ]);
  const [ValidationError, setValidationError] = useState(
    translateText("fill_the_field_error") + "."
  );

  useEffect(() => {
    if (window.localStorage.getItem("CreatedProfileNameString") !== null) {
      setCreatedProfile({
        id: window.localStorage.getItem("CreatedProfileId"),
        name: window.localStorage.getItem("CreatedProfileNameString"),
        desc: window.localStorage.getItem("CreatedProfileDesc"),
        roleType: window.localStorage.getItem("Type"),
      });
      document.getElementById("name").value = window.localStorage.getItem(
        "CreatedProfileNameString"
      );
      handlePrevType();
      document.getElementById("Description").value =
        window.localStorage.getItem("CreatedProfileDesc");
      setCreateIsDone(true);
    }
  }, []);
  const handlePrevType = () => {
    ProfileTypes.map((Type) => {
      if (Type.id === window.localStorage.getItem("Type")) {
        window.localStorage.setItem("TypeName", Type.name);
        document.getElementById("pre-selected-type").innerHTML = Type.name;
        document.getElementById("type-filter").value = Type.id;
        document
          .getElementById("option-" + Type.id + "type")
          .classList.add("pre-selected");
      }
    });
  };
  const handleInputChange = (InputId) => {
    enableSave();
  };
  const handleSwitchChange = (Id) => {
    enableSave();
  };
  const disableSaveBtn = () => {
    document.getElementById("save-btn").classList.add("disabled");
    window.localStorage.setItem("HasUnsaveChanges", 0); // 1 means true, 0 means false
    window.localStorage.setItem("BasicSettingsCreated", 1); // 1 means true, 0 means false
    setChangesApplied(false);
  };
  const enableSave = () => {
    document.getElementById("save-btn").classList.remove("disabled");
    window.localStorage.setItem("HasUnsaveChanges", 1); // 1 means true, 0 means false
    setChangesApplied(true);
  };
  const cancelOperation = () => {
    if (ChangesApplied) {
      setUnsavedChanges(true);
    } else {
      window.localStorage.removeItem("CreatedProfileId");
      window.localStorage.removeItem("CreatedProfileNameString");
      window.localStorage.removeItem("CreatedProfileDesc");
      window.localStorage.removeItem("Enabled");
      window.location.assign("/home/securityProfiles");
    }
  };
  const discardAndLeave = () => {
    window.location.assign("/home/securityProfiles");
  };
  const validateEntries = () => {
    let Name = document.getElementById("name").value;
    let Type = document.getElementById("type-filter").value;
    var IsActive;
    if (document.getElementById("status-switch-holder").classList.length > 1) {
      IsActive = false;
    } else {
      IsActive = true;
    }
    let Description = document.getElementById("Description").value;
    if (Name.length <= 0) {
      showEmptyNameError();
      window.localStorage.setItem("HasUnsaveChanges", 1);
    } else {
      if (Type.length === 0) {
        document
          .getElementById("type-select")
          .classList.add("cx-select-error-shown");
      } else {
        if (CreateIsDone) {
          setIsLoading(true);
          editCreatedProfile();
        } else {
          setIsLoading(true);
          createProfile(Name, Description, Type);
        }
      }
    }
  };
  const handleTypeChange = () => {
    enableSave();
    document
      .getElementById("type-select")
      .classList.remove("cx-select-error-shown");
  };
  const editCreatedProfile = () => {
    let NewData = {
      description: document.getElementById("Description").value,
      id: CreatedProfile.id,
      name: document.getElementById("name").value,
      roleType: document.getElementById("type-filter").value,
    };
    if (document.getElementById("status-switch-holder").classList.length > 1) {
      NewData.enabled = false;
    } else {
      NewData.enabled = true;
    }
    let Req = {
      method: "PUT",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/role",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: NewData,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        disableSaveBtn();
        let CreatedProfile = JSON.stringify({ ProfileName: NewData.name });
        let ProfileNameBase64 = Buffer.from(CreatedProfile).toString("base64");
        window.localStorage.setItem("CreatedProfileName", ProfileNameBase64);
        window.localStorage.setItem("CreatedProfileDesc", Res.data.description);
        window.localStorage.setItem("Enabled", NewData.enabled);
        window.localStorage.setItem("Type", Res.data.roleType);
        setCreatedProfile({
          id: Res.data.id,
          name: Res.data.name,
          desc: Res.data.description,
        });
        setIsLoading(false);
      })
      .catch((Err) => {
        console.log(Err.response);
        setIsLoading(false);
      });
  };
  const showEmptyNameError = () => {
    setValidationError("Please, fill the field.");
    document.getElementById("name-label-holder").classList.add("wrong");
    setTimeout(() => {
      document.getElementById("name-label-holder").classList.remove("wrong");
    }, 3000);
  };
  const showEmptyDescError = () => {
    document
      .getElementById("Description-textarea-holder")
      .classList.add("wrong");
    setTimeout(() => {
      document
        .getElementById("Description-textarea-holder")
        .classList.remove("wrong");
    }, 3000);
  };
  const closeAlert = () => {
    setUnsavedChanges(false);
  };
  const createProfile = (Name, Description, Type) => {
    let ProfileInfo = {
      description: Description,
      name: Name,
      roleType: Type,
    };
    if (document.getElementById("status-switch-holder").classList.length > 1) {
      ProfileInfo.enabled = false;
    } else {
      ProfileInfo.enabled = true;
    }
    let Req = {
      method: "POST",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/role",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: ProfileInfo,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        window.localStorage.setItem("CreatedProfileId", Res.data.id);
        window.localStorage.setItem("CreatedProfileNameString", Res.data.name);
        window.localStorage.setItem("CreatedProfileDesc", Res.data.description);
        window.localStorage.setItem("Enabled", ProfileInfo.enabled);
        window.localStorage.setItem("Type", Res.data.roleType);
        setCreatedProfile({
          id: Res.data.id,
          name: Res.data.name,
          desc: Res.data.description,
        });
        setCreateIsDone(true);
        disableSaveBtn();
        setIsLoading(false);
      })
      .catch((Err) => {
        console.log(Err.response);
        displayValidationError(Err.response.data.messages);
        setIsLoading(false);
      });
  };
  const displayValidationError = (ErrorText) => {
    if (ErrorText[0] === "Duplicate name") {
      setValidationError(translateText("duplicate_name_error"));
    }
    document.getElementById("name-label-holder").classList.add("wrong");
    setTimeout(() => {
      document.getElementById("name-label-holder").classList.remove("wrong");
    }, 3000);
  };
  const saveAndLeave = () => {
    setUnsavedChanges(false);
    let Name = document.getElementById("name").value;
    let IsActive = true;
    if (
      document.getElementById("status-switch-holder").classList.contains("off")
    ) {
      IsActive = false;
    }
    let Description = document.getElementById("Description").value;
    let Type = document.getElementById("type-filter").value;
    if (Name.length <= 0) {
      showEmptyNameError();
      window.localStorage.setItem("HasUnsaveChanges", 1);
    } else if (Type === "") {
      document
        .getElementById("type-select")
        .classList.add("cx-select-error-shown");
    } else {
      let ProfileInfo = {
        description: Description,
        name: Name,
        enabled: IsActive,
        roleType: Type,
      };
      let Req = {
        method: "POST",
        baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/role",
        headers: {
          Authorization: "Bearer " + window.localStorage.getItem("Token"),
        },
        data: ProfileInfo,
      };
      axios(Req)
        .then((Res) => {
          console.log(Res);
          window.location.assign("/home/securityProfiles");
        })
        .catch((Err) => {
          console.log(Err);
        });
    }
  };
  return (
    <React.Fragment>
      {UnsavedChanges ? (
        <UnsavedChangesAlert
          close={() => closeAlert()}
          saveAndLeave={() => saveAndLeave()}
          discardAndLeave={() => discardAndLeave()}
          LangData={props.LangData}
        />
      ) : null}
      <div className="form">
        <section className="form-header">
          <button className="return" onClick={() => cancelOperation()}>
            <i className="feather-arrow-left"></i>
          </button>
          {CreatedProfile.name ? (
            <h1>{CreatedProfile.name}</h1>
          ) : (
            <h1>{translateText("new_profile")}</h1>
          )}
          <div className="action-btn-group">
            <button onClick={() => cancelOperation()} className="cancel">
              {translateText("cancel")}
            </button>
            {IsLoading ? (
              <button
                onClick={() => null} //this button is disabled and won't act when loading is set to true
                id="save-btn"
                className="save no-action"
              >
                <img alt="" className="rotator" src={Rotator} />
              </button>
            ) : (
              <button
                onClick={() => validateEntries()}
                id="save-btn"
                className="save disabled"
              >
                {translateText("save")}
              </button>
            )}
          </div>
        </section>
        <div className="row">
          <p className="name">
            {translateText("name")} <p className="required">*</p>
          </p>
          <TextInputNoLabel
            ChangeEvent={() => handleInputChange("name")}
            Id="name"
            PlaceHolder={translateText("profile_name")}
            ValidationMessage={ValidationError}
          />
        </div>
        <div className="row">
          <p className="name">{translateText("status")}</p>
          {window.localStorage.getItem("Enabled") === "false" ? (
            <Switch
              ChangeEvent={() => handleSwitchChange("status")}
              Id="status"
              PlaceHolder={translateText("profile_name")}
              IsActive={false}
            />
          ) : (
            <Switch
              ChangeEvent={() => handleSwitchChange("status")}
              Id="status"
              PlaceHolder={translateText("profile_name")}
              IsActive={true}
            />
          )}
        </div>
        <div className="row">
          <p className="name">{translateText("type")}</p>
          {window.localStorage.getItem("Type") ? (
            <Select
              Initial=""
              PreSelected
              PreSelectedId={window.localStorage.getItem("Type")}
              Options={ProfileTypes}
              IsWithId
              Id="type"
              ChangeHandler={() => handleTypeChange()}
              ValidationError={translateText("specify_type_error") + "."}
            />
          ) : (
            <Select
              Initial={translateText("select_type")}
              Options={ProfileTypes}
              IsWithId
              Id="type"
              ChangeHandler={() => handleTypeChange()}
              ValidationError={translateText("specify_type_error") + "."}
            />
          )}
        </div>
        <div className="row">
          <p className="name float-top">{translateText("description")}</p>
          <SimpleTextArea
            ChangeEvent={() => handleInputChange("Description")}
            Id="Description"
            PlaceHolder={translateText("optional")}
            ValidationMessage={translateText("fill_the_field_error") + "."}
          />
        </div>
      </div>
    </React.Fragment>
  );
};
export default BasicSettings;
